module.exports = __webpack_public_path__ + "img/11.0731011.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/11.png
// module id = Hc8R
// module chunks = 1